'use client';

import { useEffect, useState } from 'react';
import { getAsset } from './assetStore';

const objectUrls = new Map<string, Promise<string>>();

const storedImageSrc = (url: string): Promise<string> => {
  let p = objectUrls.get(url);
  if (!p) {
    p = getAsset(url).then((blob) => URL.createObjectURL(blob)).catch(() => url);
    objectUrls.set(url, p);
  }
  return p;
};

export function useStoredImageSrc(url: string): string | null {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    void storedImageSrc(url).then((s) => { if (live) setSrc(s); });
    return () => { live = false; };
  }, [url]);
  return src;
}
